export function OurPurchaseProcess() {
  const steps = [
    {
      number: '01',
      title: 'Contact Us',
      description: 'Reach out to us by phone, email, or through our website contact form. Provide basic information about your small apartment building including location, number of units, condition, and occupancy status.',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: 'Property Evaluation',
      description: 'We\'ll schedule a convenient time to view your property. Our evaluation is quick and non-invasive. We assess the property\'s condition, location, rental income potential, and market comparables.',
      icon: 'ri-search-eye-line'
    },
    {
      number: '03',
      title: 'Receive Cash Offer',
      description: 'Within 24-48 hours of viewing your property, we\'ll present you with a fair, no-obligation cash offer. Our offers are based on current market conditions, property condition, and income potential.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '04',
      title: 'Accept and Close',
      description: 'If you accept our offer, we handle all the paperwork, legal requirements, and closing details. Choose your closing date, and we\'ll have cash in your hands in as little as 7-14 days.',
      icon: 'ri-hand-coin-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Simple Purchase Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Selling your small apartment building to us is straightforward and stress-free. Here's how it works:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-amber-50 p-8 rounded-xl h-full">
                <div className="text-6xl font-bold text-orange-200 mb-4">{step.number}</div>
                <div className="w-14 h-14 bg-orange-500 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-4xl text-orange-500"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 lg:p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl lg:text-4xl font-bold mb-6">
                Ready to Sell Your Small Apartment Building?
              </h3>
              <p className="text-xl mb-6 opacity-90">
                Get started today with a free, no-obligation cash offer. No pressure, no hassle, just a fair offer for your property.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3"></i>
                  <span>Free property evaluation</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3"></i>
                  <span>Cash offer within 24-48 hours</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3"></i>
                  <span>Close in as little as 7-14 days</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-orange-500 text-xl mr-3"></i>
                  <span>No fees, no commissions, no repairs</span>
                </li>
              </ul>
              <a 
                href="#get-offer"
                className="inline-flex items-center justify-center px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap"
              >
                Get Your Cash Offer Now
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/1436a24c25d3ad20abcd822d96fb197a.jpg"
                alt="Our Purchase Process"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}